module.exports = __webpack_public_path__ + "static/media/motorcycle.49cc6ce4.svg";